import React from 'react';
import { render, screen } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import AccountStep from './AccountStep';
import { ACCOUNT_STEP } from './copy';

const renderStep = (props = {}) =>
  render(
    <ConfigProvider>
      <AccountStep
        options={[{ label: 'Alpha Fleet', value: 7 }]}
        selected={[]}
        onChange={() => {}}
        onSearchAccounts={() => {}}
        {...props}
      />
    </ConfigProvider>,
  );

describe('management/Users AccountStep', () => {
  it('introduces the step', () => {
    renderStep();

    expect(screen.getByText(ACCOUNT_STEP.subtitle)).toBeInTheDocument();
  });

  it('marks the step as having a required field', () => {
    renderStep();

    expect(screen.getByText('Required Fields')).toBeInTheDocument();
  });

  it('offers the accounts field', () => {
    renderStep();

    expect(
      screen.getByRole('button', { name: new RegExp(ACCOUNT_STEP.label, 'i') }),
    ).toBeInTheDocument();
  });

  // The mockup also shows a required Team select. PD-4064 does not build it: the
  // grooming notes defer Teams, and there is no Team model until PD-4213.
  it('has no Team field', () => {
    renderStep();

    expect(screen.queryByText(/team/i)).not.toBeInTheDocument();
  });
});
